import React, { Component } from "react";
import UserService from "../services/user.service";
import { connect } from "react-redux";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
var QRCode = require('qrcode');

class Receive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Addresses: [],
      isLoading: true,
      cointicker: "",
      coinname: ""
    };
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillMount() {
    var cointkr = this.props.coin;
    if (cointkr == undefined || cointkr == "") {
      this.setState({
        cointicker: "VSOL"
      });
      cointkr = "VSOL";
    }
    else {
      this.setState({
        cointicker: cointkr
      })
    }


    if (cointkr == undefined || cointkr == "" || cointkr == "VSOL") {
      this.setState({
        coinname: "VSolidus™"
      });

    }
    else if (cointkr == "VDM") {
      this.setState({
        coinname: "Veridium"
      });
    }
    else if (cointkr == "BTC") {
      this.setState({
        coinname: "Bitcoin"
      });

    }
    else if (cointkr == "DOGE") {
      this.setState({
        coinname: "Dogecoin"
      });
    }
    else if (cointkr == "ETH") {
      this.setState({
        coinname: "Ethereum"
      });
    }
    else if (cointkr == "BNB") {
      this.setState({
        coinname: "Binance Smart Chain"
      });
    }
    else if (cointkr == "WVSOL-BNB") {
      this.setState({
        coinname: "WVSolidus™ - BNB"
      });
    }
    else if (cointkr == "WVSOL-ETH") {
      this.setState({
        coinname: "WVSolidus™ - ETH"
      });
    }
    else if (cointkr == "USDT") {
      this.setState({
        coinname: "Tether"
      });
    }
    else if (cointkr == "BUSD") {
      this.setState({
        coinname: "Binance USD"
      });
    }

    UserService.getaddresses(cointkr).then(
      response => {
        if (response.data.code == 100) {
          this.setState({
            Addresses: response.data.Addresses,
            isLoading: false,
          });
          this.loadQRCodeData(response.data.Addresses[0]);
        }
      },
      error => {
        this.setState({
          content:
            (error.response && error.response.data) ||
            error.message ||
            error.toString(),
          isLoading: false
        });
      }
    );
  }


  loadQRCodeData(Addreses) {
    this.setState({
      qraddress: Addreses
    });
    QRCode.toCanvas(document.getElementById('canvas'),
      Addreses, { toSJISFunc: QRCode.toSJIS }, function (error) {
        if (error) console.error(error)
        console.log('success!')
      })
  }

  handleClick = (item) => {
    this.loadQRCodeData(item.target.value);
  }

  render() {

    const { user: currentUser } = this.props;
    if (!currentUser) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-5 col-12" data-aos="fade-up" data-aos-delay="300">
        {/* <ToastContainer /> */}
        <div className="card  bounceInRight ">
          <div className="card-header">
            <h5 className="card-title animated bounceInLeft" data-aos="fade-up" data-aos-delay="500">Receive Coin <span className="text-primary">({this.state.coinname})</span></h5>
          </div>

          <div className="card-body">
            <div className="table-responsive mb-0">
              <div className="form-group">
                <label htmlFor="receiveAddress">
                  <span className="receive_coin_type"></span> Scan the QR code or copy the address to receive coin.</label>
              </div>

              <div className="info_box text-center animated rubberBand ">
                <canvas id="canvas" ></canvas>
              </div>

              <div className="input-group mt-15 mb-20 ">
                <select className="form-control" onChange={this.handleClick} value={this.state.qraddress}>
                  {this.state.Addresses.map(item => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                <div className="input-group-append">
                  <CopyToClipboard onCopy={() => toast.warning("Copy to clipboard.")} text={this.state.qraddress}>
                    <button className="btn btn-sm btn-primary"><svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M14.7379 2.76175H8.08493C6.00493 2.75375 4.29993 4.41175 4.25093 6.49075V17.2037C4.20493 19.3167 5.87993 21.0677 7.99293 21.1147C8.02393 21.1147 8.05393 21.1157 8.08493 21.1147H16.0739C18.1679 21.0297 19.8179 19.2997 19.8029 17.2037V8.03775L14.7379 2.76175Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M14.4751 2.75V5.659C14.4751 7.079 15.6231 8.23 17.0431 8.234H19.7981" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M14.2882 15.3584H8.88818" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M12.2432 11.606H8.88721" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg></button>
                  </CopyToClipboard>
                </div>
              </div>

              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.auth;
  return {
    user,
  };
}
export default connect(mapStateToProps)(Receive);






